import type { TOC } from '@ember/component/template-only'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { FidgetLoadingIndicatorComponent } from '@blakeelearning/fidget/components/fidget/loading-indicator'
import { t } from 'ember-intl'
import RouteTemplate from 'ember-route-template'
import { InlineAlert, AlertType, InlineAlertTitle } from 'teacher-ui-client/components/inline-alert'

export const ManageRolloverStepsStudentsImportValidatePage: TOC<unknown> = <template>
  <div class="mx-auto max-w-3xl px-2">
    <div class="space-y-12">
      <InlineAlert @type={{AlertType.Information}} role="alert">
        <InlineAlertTitle data-test-validate-message>
          {{t "manage.studentCsv.validateStudents"}}
        </InlineAlertTitle>
      </InlineAlert>

      <FidgetLoadingIndicatorComponent @show={{true}} @centered={{true}} @overlay={{false}} />

      <div class="text-right">
        {{! a button that is never able to be used, just says 'Validating' }}
        <UiButton class="w-48 whitespace-nowrap" disabled={{true}} @appearance={{ButtonAppearance.regular}}>
          {{t "manage.studentCsv.validateUploading"}}
        </UiButton>
      </div>
    </div>
  </div>
</template>

export default RouteTemplate(ManageRolloverStepsStudentsImportValidatePage)
